import styled from "styled-components";

import { media } from "../styles/media";

export const GeneralBranchSettingsStyles = styled.section`
  min-height: calc(100vh - 42px);

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .contentContainer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 24px;

    .tabs {
      width: 32.6%;
      background: ${({ theme }) => theme.colors.semantic.container.white};
      box-shadow: ${({ theme }) => theme.shadows.card};
      border-radius: ${({ theme }) => theme.radius[12]};
      overflow: hidden;
      position: sticky;
      top: 24px;
      animation: fadeIn 0.4s ease both;
    }

    .cardContainer {
      width: 63.8%;

      > * {
        animation: fadeIn 0.4s ease both;
      }
    }

    /* Stack the tab rail above the content panel on smaller screens. Placed
       after the base rules so the full-width override wins by source order. */
    ${media.maxTablet`
      flex-direction: column;
      gap: 16px;

      .tabs {
        width: 100%;
        position: static;
      }

      .cardContainer {
        width: 100%;
      }
    `}
  }
`;
